import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-secondary text-foreground',
        secondary: 'bg-secondary text-accent-foreground',
        outline: 'border border-border bg-transparent text-accent-foreground',
        primary: 'bg-primary-light text-primary-hover',
        warning: 'bg-warning-light text-warning',
        destructive: 'bg-destructive-light text-destructive',
        info: 'bg-info-light text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
